import { useRequest } from 'ahooks';
import { useEffect } from 'react';

import { dailypriceService } from '../services';

export const useBidAsk = (stockCode: string, show: boolean) => {
  const { data, run, mutate } = useRequest(dailypriceService.bidAskOptions, {
    manual: true,
  });

  useEffect(() => {
    if (show) {
      run(stockCode);
    } else {
      mutate([]);
    }
  }, [mutate, run, show, stockCode]);

  return data || [];
};
